/* Cadde Medikal — yeni tasarım bölümlerinin davranışları */
(function () {
  'use strict';
  if (window.cmUI) return;

  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var money = function (cents) {
    var n = (cents || 0) / 100;
    return n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
  };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var withSection = function (url) {
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=cm-ajax-products';
  };

  /* ---------- Slider ---------- */
  function initSlider(el) {
    if (el.dataset.cmReady) return;
    el.dataset.cmReady = '1';
    var track = el.querySelector('[data-cm-track]');
    var slides = $$('.cm-slider__slide', track);
    var count = el.querySelector('[data-cm-count]');
    var i = 0, timer = null;
    var delay = parseInt(el.dataset.autoplay || '0', 10) * 1000;
    function go(n) {
      if (!slides.length) return;
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      slides.forEach(function (s, k) { s.tabIndex = k === i ? 0 : -1; s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
    }
    function play() {
      if (!delay || slides.length < 2) return;
      stop();
      timer = setInterval(function () { go(i + 1); }, delay);
    }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    var prev = el.querySelector('[data-cm-prev]'), next = el.querySelector('[data-cm-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1); play(); });
    if (next) next.addEventListener('click', function () { go(i + 1); play(); });
    el.addEventListener('mouseenter', stop);
    el.addEventListener('mouseleave', play);
    var x0 = null;
    el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
      x0 = null; play();
    });
    go(0); play();
  }

  /* ---------- İçindekiler ---------- */
  function slug(t) {
    var map = { 'ç': 'c', 'ğ': 'g', 'ı': 'i', 'ö': 'o', 'ş': 's', 'ü': 'u', 'İ': 'i' };
    return t.toLowerCase().replace(/[çğıöşüİ]/g, function (c) { return map[c] || c; })
      .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60);
  }
  function initToc(wrap) {
    if (wrap.dataset.cmReady) return;
    wrap.dataset.cmReady = '1';
    var list = wrap.querySelector('[data-cm-toc]');
    var src = wrap.querySelector('[data-cm-toc-src]');
    if (!list || !src) return;
    var heads = $$('h1, h2', src);
    if (heads.length < 2) { var nav = list.closest('nav'); if (nav) nav.hidden = true; return; }
    heads.forEach(function (h) {
      if (!h.id) h.id = slug(h.textContent) || ('b' + Math.random().toString(36).slice(2, 7));
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
    });
  }

  /* ---------- Ajax ürün listeleri ---------- */
  function initAjax(el) {
    if (el.dataset.cmReady) return;
    el.dataset.cmReady = '1';
    var loaded = false;
    var load = function () {
      if (loaded) return;
      loaded = true;
      var mode = el.dataset.cmAjaxMode || 'card';
      var limit = parseInt(el.dataset.cmAjaxLimit || '8', 10);
      var exclude = el.dataset.cmAjaxExclude;
      fetch(withSection(el.dataset.cmAjax), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var target = el.querySelector('[data-cm-ajax-target]');
          var n = 0;
          $$('.cm-ajax-item', doc).forEach(function (item) {
            if (n >= limit || item.dataset.pid === exclude) return;
            var part = item.querySelector('[data-mode="' + mode + '"]');
            if (!part) return;
            while (part.firstElementChild) target.appendChild(part.firstElementChild);
            n++;
          });
          if (n > 0) el.hidden = false;
        })
        .catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var sentinel = document.createElement('span');
      sentinel.style.cssText = 'display:block;height:1px';
      el.parentNode.insertBefore(sentinel, el);
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); sentinel.remove(); load(); }
      }, { rootMargin: '600px 0px' });
      io.observe(sentinel);
      var fallback = function () { setTimeout(function () { io.disconnect(); if (sentinel.parentNode) sentinel.remove(); load(); }, 2500); };
      if (document.readyState === 'complete') fallback(); else window.addEventListener('load', fallback);
    } else {
      load();
    }
  }

  /* ---------- Karşılaştırma tablosu ---------- */
  function initCompare(el) {
    if (el.dataset.cmReady) return;
    el.dataset.cmReady = '1';
    var get = function (u) { return fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }); };
    Promise.all([get(el.dataset.self), get(el.dataset.url)]).then(function (res) {
      var self = res[0], rec = res[1];
      if (!self || !rec || !rec.products || !rec.products.length) return;
      var list = [self].concat(rec.products);
      var brandOf = function (p) {
        var t = (p.tags || []).filter(function (x) { var l = String(x).toLowerCase(); return l !== 'marka yok' && l.indexOf('cadde') < 0; })[0];
        if (t) return t;
        return p.vendor && String(p.vendor).toLowerCase().indexOf('cadde') < 0 ? p.vendor : '';
      };
      var optNames = [];
      list.forEach(function (p) {
        (p.options || []).forEach(function (o) {
          var name = typeof o === 'string' ? o : o.name;
          if (!name || name === 'Title') return;
          var key = name.toLocaleLowerCase('tr-TR');
          if (!optNames.some(function (x) { return x.toLocaleLowerCase('tr-TR') === key; })) optNames.push(name);
        });
      });
      var optVals = function (p, name) {
        var o = (p.options || []).filter(function (x) { return String(typeof x === 'string' ? x : x.name).toLocaleLowerCase('tr-TR') === name.toLocaleLowerCase('tr-TR'); })[0];
        return o && o.values ? o.values.join(', ') : '—';
      };
      var rows = [
        ['Fiyat', function (p) { return '<strong>' + money(p.price) + '</strong>'; }],
        ['Marka', function (p) { return esc(brandOf(p) || '—'); }],
        ['Ürün tipi', function (p) { return esc(p.type || '—'); }]
      ];
      optNames.forEach(function (n) { rows.push([n, function (p) { return esc(optVals(p, n)); }]); });
      rows.push(['Stok', function (p) { return p.available ? '<span class="cm-compare__ok">Stokta</span>' : 'Tükendi'; }]);
      var img = function (p) {
        var src = p.featured_image || (p.images && p.images[0]) || '';
        if (src && typeof src === 'object') src = src.src || '';
        return src ? '<img src="' + esc(src) + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" loading="lazy" width="80" height="80">' : '';
      };
      var html = '<table><thead><tr><th scope="col"><span class="cm-visually-hidden">Özellik</span></th>';
      list.forEach(function (p, k) {
        html += '<th scope="col"' + (k === 0 ? ' class="is-self"' : '') + '><a href="' + esc(p.url) + '">' + img(p) + '<span>' + esc(p.title) + '</span></a></th>';
      });
      html += '</tr></thead><tbody>';
      rows.forEach(function (r) {
        html += '<tr><th scope="row">' + esc(r[0]) + '</th>';
        list.forEach(function (p, k) { html += '<td' + (k === 0 ? ' class="is-self"' : '') + '>' + r[1](p) + '</td>'; });
        html += '</tr>';
      });
      html += '</tbody></table>';
      el.querySelector('[data-cm-compare-target]').innerHTML = html;
      el.hidden = false;
    }).catch(function () {});
  }

  /* ---------- Sekmeler ---------- */
  function initTabs(el) {
    if (el.dataset.cmReady) return;
    el.dataset.cmReady = '1';
    var tabs = $$('[role="tab"]', el);
    function select(tab) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
    }
    tabs.forEach(function (t, k) {
      t.tabIndex = t.getAttribute('aria-selected') === 'true' ? 0 : -1;
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var n = tabs[(k + d + tabs.length) % tabs.length];
        select(n); n.focus();
      });
    });
    el.cmSelect = function (type) {
      var t = tabs.filter(function (x) { return x.dataset.cmTab === type; })[0];
      if (t) select(t);
      return !!t;
    };
  }

  /* ---------- Ürün: galeri + varyantlar ---------- */
  function initProduct(root) {
    if (root.dataset.cmReady) return;
    root.dataset.cmReady = '1';
    var gallery = root.querySelector('[data-cm-gallery]');
    var slides = gallery ? $$('.cm-gallery__slide', gallery) : [];
    var thumbs = gallery ? $$('.cm-gallery__thumb', gallery) : [];
    function show(idx) {
      if (!slides.length) return;
      idx = (idx + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === idx); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === idx); });
      var th = thumbs[idx];
      if (th && th.parentNode.scrollWidth > th.parentNode.clientWidth) {
        th.parentNode.scrollTo({ left: th.offsetLeft - 40, behavior: 'smooth' });
      }
    }
    function current() { for (var k = 0; k < slides.length; k++) if (slides[k].classList.contains('is-active')) return k; return 0; }
    function showMedia(id) {
      if (!id) return;
      for (var k = 0; k < slides.length; k++) if (slides[k].dataset.mediaId === String(id)) return show(k);
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var gp = root.querySelector('[data-cm-gprev]'), gn = root.querySelector('[data-cm-gnext]');
    if (gp) gp.addEventListener('click', function () { show(current() - 1); });
    if (gn) gn.addEventListener('click', function () { show(current() + 1); });
    if (gallery) {
      var x0 = null, main = gallery.querySelector('.cm-gallery__main');
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) show(current() + (dx < 0 ? 1 : -1));
        x0 = null;
      });
    }

    var jsonEl = root.querySelector('[data-cm-product-json]');
    var data = jsonEl ? JSON.parse(jsonEl.textContent) : { variants: [] };
    var fieldsets = $$('[data-cm-option]', root);
    var form = root.querySelector('[data-cm-buy-form]');
    var freeShip = parseInt(root.dataset.freeShip || '0', 10);

    function selected() {
      return fieldsets.map(function (fs) {
        var b = fs.querySelector('.cm-opt__btn[aria-pressed="true"]');
        return b ? b.dataset.value : null;
      });
    }
    function find(opts) {
      return data.variants.filter(function (v) {
        return opts.every(function (o, k) { return o === null || v.options[k] === o; });
      })[0];
    }
    function refreshAvailability(opts) {
      fieldsets.forEach(function (fs, idx) {
        $$('.cm-opt__btn', fs).forEach(function (b) {
          var test = opts.slice();
          test[idx] = b.dataset.value;
          var ok = data.variants.some(function (v) {
            return v.available && test.every(function (o, k) { return o === null || v.options[k] === o; });
          });
          b.classList.toggle('is-out', !ok);
        });
      });
    }
    function update(fromUser) {
      var opts = selected();
      refreshAvailability(opts);
      fieldsets.forEach(function (fs, k) {
        var lbl = fs.querySelector('[data-cm-option-value]');
        if (lbl) lbl.textContent = opts[k] || '';
      });
      var v = find(opts);
      var add = root.querySelector('[data-cm-add]');
      var addText = root.querySelector('[data-cm-add-text]');
      var stock = root.querySelector('[data-cm-stock]');
      var stockText = root.querySelector('[data-cm-stock-text]');
      if (!v) {
        if (add) add.disabled = true;
        if (addText) addText.textContent = 'Bu kombinasyon yok';
        if (stock) stock.classList.add('is-out');
        if (stockText) stockText.textContent = 'Bu seçenek bulunmuyor';
        return;
      }
      form.querySelector('[data-cm-variant-id]').value = v.id;
      if (add) add.disabled = !v.available;
      if (addText) addText.textContent = v.available ? 'Sepete Ekle' : 'Tükendi';
      if (stock) stock.classList.toggle('is-out', !v.available);
      if (stockText) stockText.textContent = v.available ? data.in_stock_text : 'Bu seçenek şu an tükendi';
      var price = root.querySelector('[data-cm-price]');
      var cmp = root.querySelector('[data-cm-compare-price]');
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      if (price) { price.textContent = v.price_html; price.classList.toggle('is-sale', !!sale); }
      if (cmp) { cmp.hidden = !sale; if (sale) cmp.textContent = v.compare_html; }
      var ship = root.querySelector('[data-cm-ship]');
      var shipText = root.querySelector('[data-cm-ship-text]');
      if (ship && freeShip) {
        var free = v.price >= freeShip;
        ship.classList.toggle('is-fast', !free);
        if (shipText) shipText.textContent = free ? 'Ücretsiz Kargo' : 'Hızlı Gönderim';
      }
      var sku = root.querySelector('[data-cm-sku]');
      var skuWrap = root.querySelector('[data-cm-sku-wrap]');
      if (sku) sku.textContent = v.sku || '';
      if (skuWrap) skuWrap.hidden = !v.sku;
      if (fromUser) {
        if (v.media_id) showMedia(v.media_id);
        if (window.history && window.history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        }
      }
    }
    fieldsets.forEach(function (fs) {
      $$('.cm-opt__btn', fs).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('.cm-opt__btn', fs).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          update(true);
        });
      });
    });
    if (fieldsets.length) update(false);

    $$('[data-cm-qty]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var input = form.querySelector('[name="quantity"]');
        var n = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.cmQty, 10));
        input.value = n;
      });
    });
    $$('[data-cm-open-tab]', root).forEach(function (a) {
      a.addEventListener('click', function (e) {
        var tabs = document.querySelector('[data-cm-tabs]');
        if (tabs && tabs.cmSelect && tabs.cmSelect(a.dataset.cmOpenTab)) {
          e.preventDefault();
          tabs.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* ---------- Kategori: filtreler, sıralama, daha fazla ---------- */
  function initCollection(root) {
    if (root.dataset.cmReady) return;
    root.dataset.cmReady = '1';
    var form = root.querySelector('[data-cm-filter-form]');
    var filters = root.querySelector('[data-cm-filters]');
    function submit() {
      if (!form) return;
      var params = new URLSearchParams();
      new FormData(form).forEach(function (v, k) { if (v !== '') params.append(k, v); });
      var sort = root.querySelector('[data-cm-sort]');
      if (sort && sort.value) params.set('sort_by', sort.value);
      var qs = params.toString();
      window.location.href = form.getAttribute('action') + (qs ? '?' + qs : '');
    }
    if (form) {
      form.addEventListener('change', function (e) {
        if (e.target.type === 'number') return;
        submit();
      });
      form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
      $$('[data-cm-price-presets] button', form).forEach(function (b) {
        b.addEventListener('click', function () {
          var box = b.parentNode;
          var mn = form.querySelector('[name="' + box.dataset.minName + '"]');
          var mx = form.querySelector('[name="' + box.dataset.maxName + '"]');
          if (mn) mn.value = b.dataset.min;
          if (mx) mx.value = b.dataset.max;
          submit();
        });
      });
      $$('[data-cm-more-values]', form).forEach(function (b) {
        b.addEventListener('click', function () {
          var list = b.previousElementSibling;
          var open = list.classList.toggle('is-open');
          b.textContent = open ? 'Daha az göster' : 'Tümünü göster';
        });
      });
    }
    var sort = root.querySelector('[data-cm-sort]');
    if (sort) sort.addEventListener('change', submit);

    function setOpen(open) {
      if (!filters) return;
      root.classList.toggle('is-filters-open', open);
      document.documentElement.style.overflow = open ? 'hidden' : '';
    }
    $$('[data-cm-filters-open]', root).forEach(function (b) { b.addEventListener('click', function () { setOpen(true); }); });
    $$('[data-cm-filters-close]', root).forEach(function (b) { b.addEventListener('click', function () { setOpen(false); }); });

    var more = root.querySelector('[data-cm-next-page]');
    if (more) {
      more.addEventListener('click', function (e) {
        e.preventDefault();
        if (more.classList.contains('is-loading')) return;
        more.classList.add('is-loading');
        var url = more.getAttribute('href');
        fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + root.dataset.sectionId, { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var grid = root.querySelector('[data-cm-grid]');
            $$('[data-cm-grid] > *', doc).forEach(function (n) { grid.appendChild(n); });
            var nextLink = doc.querySelector('[data-cm-next-page]');
            var shown = grid.children.length;
            var total = parseInt(more.dataset.total || '0', 10);
            var shownEl = root.querySelector('[data-cm-shown]');
            var bar = root.querySelector('[data-cm-bar]');
            if (shownEl) shownEl.textContent = shown;
            if (bar && total) bar.style.width = Math.min(100, Math.round(shown * 100 / total)) + '%';
            var pag = root.querySelector('.cm-pagination');
            var newPag = doc.querySelector('.cm-pagination');
            if (pag && newPag) pag.innerHTML = newPag.innerHTML;
            if (nextLink) { more.setAttribute('href', nextLink.getAttribute('href')); more.classList.remove('is-loading'); }
            else more.remove();
          })
          .catch(function () { window.location.href = url; });
      });
    }
  }

  /* ---------- Yatay raflar: sağ/sol ok ---------- */
  var RAIL_SEL = '.cm-grid-products--row, .cm-grid-products--mscroll, .cm-tiles, .cm-collhero__grid';
  function initRail(el) {
    if (el.dataset.cmRail) return;
    el.dataset.cmRail = '1';
    var wrap = document.createElement('div');
    wrap.className = 'cm-rail';
    el.parentNode.insertBefore(wrap, el);
    wrap.appendChild(el);
    var mk = function (dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cm-rail__btn cm-rail__btn--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? 'Önceki' : 'Sonraki');
      b.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + (dir === 'prev' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '"/></svg>';
      b.addEventListener('click', function () {
        var step = Math.max(el.clientWidth * 0.85, 160);
        el.scrollBy({ left: dir === 'prev' ? -step : step, behavior: 'smooth' });
      });
      wrap.appendChild(b);
      return b;
    };
    var prev = mk('prev'), next = mk('next');
    var update = function () {
      var max = el.scrollWidth - el.clientWidth;
      wrap.classList.toggle('is-scrollable', max > 2);
      prev.disabled = el.scrollLeft <= 2;
      next.disabled = el.scrollLeft >= max - 2;
    };
    el.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if ('MutationObserver' in window) new MutationObserver(update).observe(el, { childList: true });
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(el);
    update();
  }

  function init(scope) {
    scope = scope || document;
    $$(RAIL_SEL, scope).forEach(initRail);
    $$('[data-cm-slider]', scope).forEach(initSlider);
    $$('[data-cm-toc-wrap]', scope).forEach(initToc);
    $$('[data-cm-tabs]', scope).forEach(initTabs);
    $$('[data-cm-product]', scope).forEach(initProduct);
    $$('[data-cm-ajax]', scope).forEach(initAjax);
    $$('[data-cm-compare]', scope).forEach(initCompare);
    $$('[data-cm-collection]', scope).forEach(initCollection);
  }

  window.cmUI = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
